/**
 * Classic M: amoeba and butterflies together (docs/spec/03 §2). The amoeba bursts every butterfly
 * it touches. Plug the gaps in its cavern roof and it can never grow to 200, so it ends as diamonds;
 * leave them open and it spills out and turns to stone.
 */

import type { CaveDef } from '../types';

export const caveM: CaveDef = {
  id: 'M',
  name: 'DOOMSDAY',
  hint: 'Let the green meet the wings, but keep it in its cage.',
  intermission: false,
  colors: [5, 10, 7],
  diamondValue: 25,
  extraValue: 40,
  amoebaTime: 25,
  fill: { base: '.', items: [['r', 7], ['d', 5]] },
  levels: [
    { seed: 2601, diamonds: 30, time: 150 },
    { seed: 2602, diamonds: 33, time: 140 },
    { seed: 2603, diamonds: 36, time: 130 },
    { seed: 2604, diamonds: 40, time: 120 },
    { seed: 2605, diamonds: 44, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...???????????????????????????????????W',
    'W.P.???????????????????????????????????W',
    'W...???????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W???????r..?.??r..????r..??.?r..???????W',
    'W?????www wwdwww wwwwww wwwdww www?????W',
    'W?????w??????????????????????????w?????W',
    'W?????w?? b ?????? b ????? b ????w?????W',
    'W?????w??   ??????   ?????   ????w?????W',
    'W?????w??????????????????????????w?????W',
    'W?????w??????????????????????????w?????W',
    'W?????w????????????aa????????????w?????W',
    'W?????w?? b ?????????????? b ????w?????W',
    'W?????w??   ??????????????   ????w?????W',
    'W?????wwwwwwwwwwwwwwwwwwwwwwwwwwww?????W',
    'W??????????????????????????????????????W',
    'W????????????????????????????????????X?W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
